import React from "react";
import "./CustomTable.css"

const ErrorPage = () => {
    return (
        <h4 className="container1-h1">Access Denied</h4>
    )
}

export default ErrorPage;